<script>
import availabilityService from "@/services/availability.service"
import VueDatepicker from '@vuepic/vue-datepicker'
import moment from 'moment'
import IcoMoon from "@/components/Icon/Icon.vue";
import { Form as MainForm, Field, ErrorMessage } from "vee-validate"
import { ref } from 'vue'

export default {
    name: 'AvailabilityButton',
    components: {
        IcoMoon,
        MainForm,
        Field,
        ErrorMessage,
        VueDatepicker,
    },
    data() {
        return {
            availabilities: [],
            duration: 60,
            isActive: false,
        }
    },
    setup() {
        const dateStart = ref(moment())
        const dateEnd = ref(moment().add(7, 'days'))
        
        return {
            dateStart,
            dateEnd,
        }
    },
    props: {
        externDuration: {
            //type: String,
            required: true,
        },
    },
    watch: {
        externDuration: function(newVal) {
            this.duration = newVal
        },
    },
    methods: {
        timeFormatted(time) {
            const timeArray = time.split(':');
            const minutes = timeArray[1].padStart(2, '0');
            return timeArray[0].padStart(2, '0') + 'h' + (minutes != '00' ? minutes : '');
        },
        updateForm(availability) {
            let item = {
                'date': availability.date.format('YYYY-MM-DD'),
                'time': availability.time,
                'duration': this.duration,
            };
            this.$emit('action-on-form', item)
        },
        handleSearch(item) {
            availabilityService.get(this.$store.state.account.uuid, {
                date_start: moment(this.dateStart).format('YYYY-MM-DD'),
                date_end: moment(this.dateEnd).format('YYYY-MM-DD'),
                duration: this.duration,
            })
            .then(data => {
                if(data['availabilities'].length)
                {
                    this.availabilities = [];

                    data['availabilities'].forEach(el => {
                        el.date = moment(el.date)

                        const timeArray = el.time.split(':')
                        el.date.set({hour: timeArray[0], minute: timeArray[1]})

                        const interval = Math.floor(el.duration / this.duration)
                        for (let i = 0; i < interval; i++) {
                            this.availabilities.push({
                                date: el.date,
                                time: el.date.format('HH:mm:ss'),
                                duration: this.duration,
                            })

                            el.date.add(this.duration, 'minutes')
                        }
                    });
                }
            });
        },
    },
}

</script>

<template>
    <div class="mb-3 p-1 border border-orange-300 bg-white">
        <div class="cursor-pointer flex justify-between" @click="this.isActive = !this.isActive">
            <div>Disponibilités</div>
            <div class="flex flex-col justify-center">
                <div v-if="this.isActive" class="inline-block p-1 border border-t-0 border-r-2 border-b-2 border-l-0 border-black -rotate-[135deg]"></div>
                <div v-else class="inline-block p-1 border border-t-0 border-r-2 border-b-2 border-l-0 border-black rotate-45"></div>
            </div>
        </div>
        <div v-show="isActive" class="h-[360px]">
            <MainForm @submit="handleSearch">
                <div class="form-group grid grid-cols-form-person gap-2 mt-6">
                    <span class="flex flex-col justify-center">Du</span>
                    <VueDatepicker
                        v-model="dateStart"
                        :clearable="true"
                        :enableTimePicker="false"
                        locale="fr"
                        cancelText="Annuler"
                        selectText="Valider"
                        format="dd/MM/yyyy"
                        :typeable="true"
                        text-input
                        auto-apply
                        :style="{'width': '150px'}"
                        :model-value="dateStart"
                    />

                    <span class="flex flex-col justify-center">au</span>
                    <VueDatepicker
                        v-model="dateEnd"
                        :clearable="true"
                        :enableTimePicker="false"
                        locale="fr"
                        cancelText="Annuler"
                        selectText="Valider"
                        format="dd/MM/yyyy"
                        :typeable="true"
                        text-input
                        auto-apply
                        :style="{'width': '150px'}"
                        :model-value="dateEnd"
                    />

                    <span class="flex flex-col justify-center">Durée</span>
                    <Field name="duration" v-model="duration" class="w-20 form-control form-input" type="number" />
                </div>
                <div class="form-group flex justify-center gap-2 w-11/12 mx-auto mt-5 pt-2 pb-2">
                    <button class="bg-transparent hover:bg-orange-500 text-orange-300 font-semibold hover:text-white py-1 px-2 border border-orange-500 hover:border-transparent rounded" type="submit">
                        Chercher
                    </button>
                </div>
            </MainForm>

            <div class="h-32 overflow-auto text-sm mt-5">
                <div class="border-b border-slate-200 p-1" v-for="availability in availabilities" :key="availability.id">
                    <p class="flex justify-between mr-2">
                        Le {{ availability.date.format('DD/MM/YYYY') }}
                        à {{ timeFormatted(availability.time) }}
                        <button class="w-4" @click="updateForm(availability)">
                            <IcoMoon name="add_box" :size="25" color="#f7ca90" />
                        </button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
